export { default }from './Card';
